<rid-assignment-background />

<div class="relative flex size-full flex-col items-center justify-center gap-8">
  <div class="max-w-2xl drop-shadow-xl" [class.opacity-0]="!showReward()" [class.anim-pop-in]="showReward()">
    <img [src]="$lpApiService.getAssetUrl(reward().image)" [alt]="reward().name" class="block max-h-[60vh] w-auto object-contain" />
  </div>

  <rid-button
    [class.opacity-0]="!showButton()"
    [class.pointer-events-none]="!showButton()"
    [class.anim-pop-in]="showButton()"
    content="Plaats in het boek"
    (click)="placeInBook()"
  />
</div>
